<div class="card">
  <div class="card-header d-flex justify-content-between pb-0">
    <span class="card-title h4 text-primary">{{ title }}</span>
  </div>
  <div class="card-body">
    <div class="row flex-wrap">
      <div class="d-flex flex-column mt-1 col-lg-6 col-md-7 col-12">
        <div class="mr-1 ml-1" *ngFor="let count of counts">
          <p class="card-text mb-50 font-weight-bold">{{ count.title }}</p>
          <span class="font-large-1 font-weight-bold">{{ count.count }}</span>
          <hr />
        </div>
      </div>
      <div class="col-lg-6 col-md-5 col-12 d-flex justify-content-center" #chartRef>
        <div id="chartOptions">
          <!-- Apexchart component-->
          <apx-chart [series]="chartOptions.series" [chart]="{
              height: 400,
              width:
                isMenuToggled === false
                  ? chartRef.offsetWidth
                  : chartOptions.chart.width,
              type: 'bar',
              toolbar: {
                show: false
              }
            }" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
            [xaxis]="chartOptions.xaxis" [colors]="chartOptions.colors" [grid]="chartOptions.grid"></apx-chart>
          <!-- / Apexchart component-->
        </div>
      </div>
    </div>
  </div>
</div>